import React from 'react'
import ComponentConfig, {
  ComponentConfigProps,
  SaveButton,
  Footer,
} from 'organization/Event/DashboardConfig/ComponentConfigPanel'
import {useForm} from 'react-hook-form'
import {useNiftyFiftyUpdate} from 'Event/template/NiftyFifty'
import Settings from 'Event/template/NiftyFifty/Dashboard/Resources/ResourceList/ResourceListConfig/Settings'
import Styling from 'Event/template/NiftyFifty/Dashboard/Resources/ResourceList/ResourceListConfig/Styling'
import SettingsPanel from 'organization/Event/DashboardConfig/ComponentConfigPanel/SettingsPanel'
import StylingPanel from 'organization/Event/DashboardConfig/ComponentConfigPanel/StylingPanel'
import {useAddTranslation} from 'Event/LanguageProvider'

export default function ResourceListConfig(props: ComponentConfigProps) {
  const {showing: isVisible, onClose} = props
  const {control, register, handleSubmit, formState} = useForm()
  const updateTemplate = useNiftyFiftyUpdate()
  const addTranslation = useAddTranslation()

  const submit = (data: any) => {
    const {rowBackgroundPrimary, rowBackgroundSecondary, ...resource} = data
    updateTemplate({
      localization: addTranslation({
        resource_list_title: resource.title,
        resource_menu_title: resource.menuTitle,
      }),
      rowBackgroundPrimary,
      rowBackgroundSecondary,
      resourceList: {
        isVisible: resource.isVisible,
        title: '{{resource_list_title}}',
        menuTitle: '{{resource_menu_title}}',
        color: resource.color,
        linkColor: resource.linkColor,
      },
    })

    onClose()
  }

  return (
    <ComponentConfig
      showing={isVisible}
      onClose={onClose}
      title="Resources"
      onSubmit={handleSubmit(submit)}
      hasChanges={formState.isDirty}
    >
      <SettingsPanel>
        <Settings control={control} register={register} />
      </SettingsPanel>
      <StylingPanel>
        <Styling control={control} />
      </StylingPanel>
      <Footer>
        <SaveButton type="submit" />
      </Footer>
    </ComponentConfig>
  )
}
